/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TrainingPlanTypeEnum } from './trainingPlanTypeEnum';


/**
 * 
 */
export interface PartialUserInfoAssistantSubscription { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    organisationId?: number;
    /**
     * 
     */
    organisationName?: string;
    /**
     * 
     */
    organisationRequireStudentnumber?: boolean;
    /**
     * 
     */
    trainingId?: number;
    /**
     * 
     */
    trainingName?: string;
    /**
     * 
     */
    studentnumber?: string;
    /**
     * 
     */
    coordinatingSupervisorId?: number;
    /**
     * 
     */
    coordinatingSupervisorName?: string;
    /**
     * 
     */
    licenseFrom?: string;
    /**
     * 
     */
    licenseTo?: string;
    /**
     * 
     */
    campusId?: string;
    /**
     * 
     */
    campusName?: string;
    /**
     * 
     */
    campusesAvailable?: boolean;
    /**
     * 
     */
    licenseAccountId?: number;
    /**
     * 
     */
    licenseAccountName?: string;
    /**
     * 
     */
    status?: PartialUserInfoAssistantSubscription.StatusEnum;
    /**
     * 
     */
    isDefault?: boolean;
    /**
     * 
     */
    isArchived?: boolean;
    trainingPlanType?: TrainingPlanTypeEnum;
    /**
     * 
     */
    internshipYear?: number;
}
export namespace PartialUserInfoAssistantSubscription {
    export type StatusEnum = 'active' | 'archived' | 'expired';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Archived: 'archived' as StatusEnum,
        Expired: 'expired' as StatusEnum
    };
}


